import type { TextProps } from "../../../Text";
import type { AvatarsViewProps } from "../types";

export const AVATARS_VIEW_TEXT_TYPOGRAPHY_STYLE_BY_AVATARS_VIEW_SIZE_MAP: Record<
    AvatarsViewProps["size"],
    TextProps["typographyStyle"]
> = {
    "24": "caption-s",
    "36": "body-m",
    "44": "body-m",
    "56": "body-m",
    "72": "body-l",
    "96": "display-m",
};
